import { render } from "./app-badge.vue?vue&type=template&id=eab0cda8"
import script from "./app-badge.vue?vue&type=script&lang=js"
export * from "./app-badge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/badge/app-badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eab0cda8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eab0cda8', __exports__)) {
    console.log('reload')
    api.reload('eab0cda8', __exports__)
  }
  
  module.hot.accept("./app-badge.vue?vue&type=template&id=eab0cda8", () => {
    console.log('re-render')
    api.rerender('eab0cda8', render)
  })

}


export default __exports__